import React from 'react';
import { useSnackbar } from 'notistack';
import { snackbarService } from '../services/snackbarService';

const SnackbarHelper = () => {
  const { enqueueSnackbar } = useSnackbar();
  snackbarService.setSnackbar(enqueueSnackbar);
  return null;
};

export default SnackbarHelper;
